const operators = {
  number: [
    { name: "=", label: "is" },
    { name: "!=", label: "is not" },
    { name: "<", label: "less than" },
    { name: ">", label: "greater than" },
    { name: "<=", label: "less than or equal to" },
    { name: ">=", label: "greater than or equal to" },
    { name: "between", label: "between" },
    // { name: "notBetween", label: "not between" },
  ],
  text: [
    { name: "=", label: "is" },
    { name: "!=", label: "is not" },
    { name: "contains", label: "contains" },
    { name: "beginsWith", label: "begins with" },
    { name: "endsWith", label: "ends with" },
    { name: "doesNotContain", label: "does not contain" },
  ],
  date: [
    { name: ">", label: "greater than" },
    { name: "<", label: "less than" },
  ],
  birthYear: [
    { name: "<", label: "less than" },
    { name: ">", label: "greater than" },
    { name: "<=", label: "less than or equal to" },
    { name: ">=", label: "greater than or equal to" },
    { name: "between", label: "between" },
  ],
};

export default operators;
